{
  "action": {
    "ok": "OK",
    "cancel": "Cancelar",
    "save": "Salvar",
    "saved": "Salvo",
    "close": "Fechar",
    "yes": "Sim",
    "no": "Não",
    "delete": "Excluir",
    "remove": "Remover",
    "add": "Adicionar",
    "edit": "Editar",
    "rename": "Renomear",
    "retry": "Tentar novamente",
    "reset": "Redefinir",
    "apply": "Aplicar",
    "confirm": "Confirmar",
    "back": "Voltar",
    "next": "Avançar",
    "done": "Concluído",
    "refresh": "Atualizar",
    "copy": "Copiar",
    "copied": "Copiado",
    "open": "Abrir",
    "start": "Iniciar",
    "stop": "Parar",
    "pause": "Pausar",
    "resume": "Retomar",
    "continue": "Continuar",
    "clear": "Limpar",
    "search": "Buscar",
    "loading": "Carregando…",
    "saving": "Salvando…",
    "searchPlaceholder": "Buscar…",
    "always": "Sempre",
    "deny": "Negar",
    "undo": "Desfazer",
    "all": "Todos"
  },
  "confirm": {
    "title": "Aprovação necessária: {{tool}}",
    "descriptionEdit": "O agente deseja modificar um arquivo. Revise a solicitação abaixo e decida se deseja prosseguir.",
    "descriptionTool": "O agente deseja executar esta ferramenta. Revise a solicitação abaixo e decida se deseja prosseguir.",
    "fileModification": "Modificação de arquivo",
    "toolExecution": "Execução de ferramenta",
    "riskSuffix": "risco {{risk}}",
    "command": "Comando",
    "inputLabel": "Entrada:",
    "trustSuggestionTitle": "Sugestão de padrão de confiança",
    "trustSuggestionHint": "Escolher Sempre vai permitir chamadas correspondentes para este projeto.",
    "yoloDestructiveNote": "YOLO está ativado. Esta confirmação ainda é exibida porque a solicitação foi classificada como destrutiva.",
    "skipApprovalsTitle": "Pular aprovações futuras",
    "skipApprovalsHint": "Ative o modo YOLO e o agente executará sem perguntar. Operações destrutivas ainda exigem confirmação.",
    "enableYoloTitle": "Ativar modo YOLO (aprovar automaticamente esta e futuras chamadas não destrutivas)",
    "enableYoloBtn": "Ativar YOLO",
    "denyAlways": "Negar sempre",
    "denyAlwaysTitle": "Rejeitar esta e todas as futuras chamadas correspondentes ao padrão (d)",
    "noTitle": "Rejeitar esta única chamada (Esc / n)",
    "alwaysTitle": "Aprovar e lembrar o padrão para o projeto (a)",
    "yesTitle": "Aprovar esta única chamada (y)"
  },
  "status": {
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "connecting": "Conectando…",
    "reconnecting": "Reconectando…",
    "ready": "Pronto",
    "error": "Erro",
    "offline": "Offline",
    "online": "Online",
    "live": "Ao vivo",
    "budgetWarning": "alerta de orçamento",
    "running": "Em execução",
    "inProgress": "Em progresso",
    "working": "trabalhando"
  },
  "time": {
    "justNow": "agora mesmo",
    "secondsAgo_one": "há {{count}} segundo",
    "secondsAgo_other": "há {{count}} segundos",
    "minutesAgo_one": "há {{count}} minuto",
    "minutesAgo_other": "há {{count}} minutos",
    "hoursAgo_one": "há {{count}} hora",
    "hoursAgo_other": "há {{count}} horas",
    "daysAgo_one": "há {{count}} dia",
    "daysAgo_other": "há {{count}} dias",
    "compactSecondsAgo": "há {{count}} s",
    "compactMinutesAgo": "há {{count}} min",
    "compactHoursAgo": "há {{count}} h"
  },
  "error": {
    "title": "Algo deu errado",
    "body": "Ocorreu um erro de renderização. Sua sessão ainda está ativa no servidor — recarregar continuará de onde você parou.",
    "reload": "Recarregar página",
    "tryAgain": "Tentar novamente"
  },
  "sparkline": {
    "noActivity": "Sem atividade",
    "noActivityYet": "Sem atividade ainda",
    "activityMax": "Sparkline de atividade: máx {{count}} eventos",
    "activityPeak": "Sparkline de atividade — pico {{count}} eventos/intervalo"
  }
}
